import React, { useEffect, useState } from "react";
import { useStore } from "../store";
import Alert from "./Alert";
import "./BottomMenu.css";
import { load } from "js-yaml";

const BottomMenu = React.forwardRef((props, ref) => {
  const setVisibility = useStore((state) => state.setResultVisible);
  const setAlertMessage = useStore((state) => state.setAlertMsg);
  const setQuery = useStore((state) => state.setQuery);
  const role1 = useStore((state) => state.role1);
  const [join, showJoin] = useState(false);
  const [about, showAbout] = useState(false);
  const [arround, showArround] = useState(false);
  const [roles, setRoles] = useState([]);
  const [roleAlert, showRoleAlert] = useState(false);

  // /**
  //  * 타이핑을 할 때마다 서치 키워드(state)를 업데이트
  //  * @param {*} e
  //  */
  // const onType = (e) => {
  //   e.preventDefault();
  //   setQuery({ type: "name", token: e.target.value, time: Date.now() });
  // };

  /**
   * 서치 버튼을 누르면 검색 결과 영역을 보이도록 상태 변경
   * @param {*} e
   */
  const onSearch = (e) => {
    e.preventDefault();
    setVisibility(true);
    setQuery({
      type: "name",
      token: document.querySelector("#input-token").value,
      time: Date.now(),
    });
  };

  /**
   * 검색창에 입력하고 엔터 키를 눌렀을 때 검색 실행되도록
   * @param {*} e
   * @returns
   */
  const onKeyPressed = (e) => {
    const keyPressed = e.keyCode || e.which;
    if (keyPressed === 13) {
      // 엔터키 누르면 검색 실행
      e.preventDefault();
      setVisibility(true);
      setQuery({ type: "name", token: e.target.value });
      return false;
    }
  };

  const onClickDropdownItem = (e) => {
    e.preventDefault();

    if (role1 == e.target.innerText) {
      setAlertMessage({ msg: "Already Selected", time: Date.now() });
    } else {
      //[설정/스피어] 변화 시간 조절
      const delay1 = 100,
        delay2 = 300,
        delay3 = 500;
      let roles = useStore.getState().roles.slice();

      setTimeout(() => {
        useStore.setState({
          role1: [e.target.innerText, Date.now()],
        });

        roles.splice(roles.indexOf(e.target.innerText), 1);
      }, delay1);
      setTimeout(() => {
        const idx = Math.floor(roles.length * Math.random());
        const removed = roles.splice(idx, 1)[0];
        useStore.setState({ role2: [removed, Date.now()] });
      }, delay2);
      setTimeout(() => {
        const idx = Math.floor(roles.length * Math.random());
        const removed = roles.splice(idx, 1)[0];
        useStore.setState({ role3: [removed, Date.now()] });
      }, delay3);
    }
  };

  const onClickJoin = (e) => {
    e.preventDefault();
    setAlertMessage("Ready");
  };

  const onClickAbout = (e) => {
    e.preventDefault();
    setAlertMessage("Ready");
  };

  const onClickArround = (e) => {
    e.preventDefault();
    setAlertMessage("Ready");
  };

  useEffect(() => {
    fetch("members.yaml")
      .then((r) => r.text())
      .then((text) => {
        return load(text);
      })
      .then((data) => {
        const _roles = data.map((member) => member.role[0]);
        setRoles([...new Set(_roles)]);
      });
  }, []);

  return (
    <>
      {join ? <Alert message={"Ready"} /> : null}
      {about ? <Alert message={"Ready"} /> : null}
      {arround ? <Alert message={"Ready"} /> : null}
      {roleAlert ? <Alert message={"Already selected"} /> : null}

      <nav ref={ref}>
        {/* <span className={"nav-join"} onClick={(e) => onClickJoin(e)}>
          {" "}
          join{" "}
        </span>
        <span className={"nav-about"} onClick={(e) => onClickAbout(e)}>
          {" "}
          about us{" "}
        </span>
        <span className={"nav-arround"} onClick={(e) => onClickArround(e)}>
          {" "}
          arround me{" "}
        </span> */}

        <div className="dropdown">
          <div>
            {" "}
            Circle type
            <img
              className={"scroll-arrow"}
              src={"/assets/images/arrow_default.png"}
            ></img>
            <img
              className={"scroll-arrow-over"}
              src={"/assets/images/arrow_over.png"}
            ></img>
          </div>
          <div className={"dropdown-content-wrapper"}>
            <div className="dropdown-content">
              {roles.map((role, i) => (
                <a href="#" onClick={(e) => onClickDropdownItem(e)}>
                  {role}
                </a>
              ))}
            </div>
          </div>
        </div>
        <form onKeyDown={(e) => onKeyPressed(e)}>
          <input
            id="input-token"
            type="text"
            placeholder="name search"
            // onChange={(e) => onType(e)}
          />
          <button type="button" name="search" onClick={(e) => onSearch(e)}>
            <img className="show search-icon" src="/assets/images/search.png" />
          </button>
        </form>
      </nav>
    </>
  );
});

export default BottomMenu;
